import { useEffect, useState } from 'preact/hooks';
import { Icon } from './Icon';

/** A thin banner shown only while `navigator.onLine` is false. Registration and status still work offline (queued); this just says so. */
export function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div class="c-offline-banner" role="status">
      <Icon name="wifi-off" size={16} />
      You're offline — your work is saved on this device and will be sent when you're back online.
    </div>
  );
}
